var map = {
	"./asset-hyperlink.json": 2770,
	"./blockquote.json": 3741,
	"./document.json": 3847,
	"./embedded-asset-block.json": 6609,
	"./embedded-entry-block.json": 5751,
	"./embedded-entry-inline.json": 6228,
	"./embedded-resource-block.json": 7086,
	"./embedded-resource-inline.json": 4139,
	"./entry-hyperlink.json": 9304,
	"./heading-1.json": 7973,
	"./heading-2.json": 803,
	"./heading-3.json": 766,
	"./heading-4.json": 8806,
	"./heading-5.json": 8256,
	"./heading-6.json": 8856,
	"./hr.json": 2760,
	"./hyperlink.json": 3223,
	"./list-item.json": 4966,
	"./ordered-list.json": 4420,
	"./paragraph.json": 5018,
	"./resource-hyperlink.json": 657,
	"./table-cell.json": 924,
	"./table-header-cell.json": 1262,
	"./table-row.json": 8686,
	"./table.json": 1764,
	"./text.json": 4350,
	"./unordered-list.json": 9478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6079;